import styled from "styled-components";
import { defaultBreakpoints } from "styled-media-query";

type StyledProps = {
  image?: string;
};

export const Wrapper = styled.div`
  box-shadow: ${({ theme }) => `0 0  10px ${theme.default.color.text.light}`};
  border-radius: 8px;
  margin: 1rem 0;
  cursor: pointer;
`;

export const CatagoryWrapper = styled.div`
  background-color: white;
  margin-top: auto;
  text-transform: uppercase;
  padding: 0 1rem;
  font-family:  ${({ theme }) => theme.default.fontFamily.secondaryFont};
  font-size: 11px;
  font-style: normal;
  font-weight: 900;
  line-height: 13px;
  letter-spacing: 0.05em;
  text-align: left;
`;

export const InfoWrapper = styled.div`
  padding: 0 1rem 1rem 1rem;
`;

export const DateWrapper = styled.div`
  color: ${({ theme }) => theme.default.color.primary};
  font-size: 12px;
  display: flex;
  justify-content: flex-start;
  font-family:  ${({ theme }) => theme.default.fontFamily.secondaryFont};
  font-size: 13px;
  font-style: normal;
  font-weight: 900;
  line-height: 16px;
  letter-spacing: 0.05em;
  text-align: left;
`;

export const Title = styled.h4`
  font-family:  ${({ theme }) => theme.default.fontFamily.primaryFont};
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
  letter-spacing: 0em;
  text-align: left;
`;

export const LocationWrapper = styled.div`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.default.color.text.medium};
  font-size: 12px;
  padding-top: 1rem;
  font-family:  ${({ theme }) => theme.default.fontFamily.secondaryFont};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 17px;
  letter-spacing: 0em;
  text-align: left;

  span {
    padding-left: 0.2rem;
  }
`;

export const Image = styled.div<StyledProps>`
  width: 100%;
  height: 140px;
  border-radius: 8px 8px 0 0;
  background-image: ${({ image }) => image && `url(${image})`};
  background-position: center;
  background-repeat: no-repeat, repeat;
  background-size: cover;
  display: flex;
`;
